export default "__VITE_ASSET__SuHDQH81__"